(function () {
  'use strict';

  var nativeProductFormSelector = 'form.product__form';
  var customizerSelector = '.product-customizer-options';
  var requiredOptionSelector = '.product-customizer-option[data-min-selections], .product-customizer-option.option-required';

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var styles = window.getComputedStyle(element);

    return styles.display !== 'none' && styles.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function getCustomizer(form) {
    var scope = form.closest('.product-single__details') || form.closest('[data-section-type="product-template"]');
    var customizers;
    var index;

    if (!scope) {
      return null;
    }

    customizers = scope.querySelectorAll(customizerSelector);

    for (index = 0; index < customizers.length; index += 1) {
      if (isVisible(customizers[index])) {
        return customizers[index];
      }
    }

    return null;
  }

  function markMissing(option) {
    var message = option.querySelector('.product-customizer-selections-message');
    var firstInput = option.querySelector('input:not([type="hidden"])');

    option.classList.add('missing-required');

    if (message) {
      message.hidden = false;
      message.setAttribute('role', 'alert');
      message.setAttribute('aria-live', 'polite');
    }

    if (firstInput) {
      firstInput.setAttribute('aria-invalid', 'true');
    }

    return firstInput;
  }

  function getRequiredSelectionState(form) {
    var customizer = getCustomizer(form);
    var requiredOptions;
    var missingOptions = [];
    var index;

    if (!customizer) {
      return { state: 'complete', customizer: null, hasRequiredOptions: false, missingOptions: [] };
    }

    if (customizer.getAttribute('data-product-options-loaded') !== 'true') {
      return { state: 'loading', customizer: customizer, hasRequiredOptions: true, missingOptions: [] };
    }

    requiredOptions = customizer.querySelectorAll(requiredOptionSelector);

    for (index = 0; index < requiredOptions.length; index += 1) {
      var option = requiredOptions[index];

      if (!isVisible(option)) {
        continue;
      }

      var minimum = parseInt(option.getAttribute('data-min-selections'), 10);
      var isRequiredRadio = option.classList.contains('option-required') && option.querySelector('input[type="radio"]');
      var selected = option.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked:not(:disabled)').length;

      if (isRequiredRadio && (!isFinite(minimum) || minimum < 1)) {
        minimum = 1;
      }

      if (!isFinite(minimum) || minimum < 1 || selected >= minimum) {
        continue;
      }

      missingOptions.push(option);
    }

    return {
      state: missingOptions.length ? 'incomplete' : 'complete',
      customizer: customizer,
      hasRequiredOptions: requiredOptions.length > 0,
      missingOptions: missingOptions
    };
  }

  function validateRequiredSelections(form) {
    var result = getRequiredSelectionState(form);
    var firstMissingInput = null;
    var index;

    if (result.state === 'complete') {
      return true;
    }

    for (index = 0; index < result.missingOptions.length; index += 1) {
      var firstInput = markMissing(result.missingOptions[index]);

      if (!firstMissingInput && firstInput) {
        firstMissingInput = firstInput;
      }
    }

    if (firstMissingInput) {
      window.requestAnimationFrame(function () {
        firstMissingInput.focus();
      });
    }

    return false;
  }

  function isNativeProductForm(form) {
    return form && form.matches && form.matches(nativeProductFormSelector);
  }

  function hasRequiredCustomizer(form) {
    var customizer = getCustomizer(form);

    return Boolean(customizer && customizer.querySelector(requiredOptionSelector));
  }

  function syncAddToCartState(form) {
    var result = getRequiredSelectionState(form);
    var button = form.querySelector('button[data-add-to-cart]');
    var quickPurchase = form.querySelector('[data-ginyhome-quick-purchase-trigger]');
    var unavailable = button ? button.disabled : quickPurchase && quickPurchase.getAttribute('data-ginyhome-available') !== 'true';
    var blocked;

    if (!button && !quickPurchase) {
      return;
    }

    if (!result.customizer || !result.hasRequiredOptions) {
      form.removeAttribute('data-ginyhome-customizer-state');
      if (button) {
        button.removeAttribute('data-ginyhome-personalization-disabled');
        button.removeAttribute('aria-disabled');
      }
      if (quickPurchase) {
        quickPurchase.removeAttribute('data-ginyhome-personalization-disabled');
        quickPurchase.removeAttribute('aria-disabled');
        quickPurchase.disabled = unavailable;
      }
      return;
    }

    blocked = result.state !== 'complete';
    form.setAttribute('data-ginyhome-customizer-state', result.state);
    if (button) {
      button.setAttribute('data-ginyhome-personalization-disabled', blocked ? 'true' : 'false');

      if (blocked) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    }
    if (quickPurchase) {
      quickPurchase.setAttribute('data-ginyhome-personalization-disabled', blocked ? 'true' : 'false');
      quickPurchase.disabled = blocked || unavailable;

      if (blocked) {
        quickPurchase.setAttribute('aria-disabled', 'true');
      } else {
        quickPurchase.removeAttribute('aria-disabled');
      }
    }
  }

  function syncPersonalizationAccordion(form) {
    var scope = form.closest('.product-single__details') || form.closest('[data-section-type="product-template"]');
    var accordion = scope && scope.querySelector('[data-personalization-accordion]');
    var customizer = getCustomizer(form);
    var hasOptions = Boolean(customizer && customizer.querySelector('.product-customizer-option'));

    if (!accordion) {
      return;
    }

    accordion.hidden = !hasOptions;
    if (!hasOptions) {
      accordion.removeAttribute('open');
    }
  }

  function syncBuyNowSafety(form) {
    var buyNow = form.querySelector('.ginyhome-product__buy-now');
    var nativeBuyNow;
    var disabled;

    if (!buyNow) {
      return;
    }

    disabled = hasRequiredCustomizer(form);
    nativeBuyNow = buyNow.querySelector('.pc_buy_now_handler, .shopify-payment-button');

    if (!nativeBuyNow) {
      return;
    }

    nativeBuyNow.hidden = disabled;
    nativeBuyNow.setAttribute('aria-hidden', disabled ? 'true' : 'false');
  }

  function observeBuyNowSafety() {
    var forms = document.querySelectorAll(nativeProductFormSelector);
    var index;

    for (index = 0; index < forms.length; index += 1) {
      syncBuyNowSafety(forms[index]);
      syncPersonalizationAccordion(forms[index]);
      syncAddToCartState(forms[index]);

      if (window.MutationObserver) {
        new MutationObserver(function () {
          syncBuyNowSafety(this.form);
          syncPersonalizationAccordion(this.form);
          syncAddToCartState(this.form);
        }.bind({ form: forms[index] })).observe(forms[index], {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'data-product-options-loaded', 'style']
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBuyNowSafety);
  } else {
    observeBuyNowSafety();
  }

  document.addEventListener('submit', function (event) {
    if (!isNativeProductForm(event.target) || validateRequiredSelections(event.target)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('input', function (event) {
    var form = event.target.closest && event.target.closest(nativeProductFormSelector);

    if (form) {
      syncAddToCartState(form);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var form = event.target.closest && event.target.closest(nativeProductFormSelector);

    if (form) {
      syncAddToCartState(form);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[data-add-to-cart], .shopify-payment-button__button, [data-ginyhome-quick-purchase-trigger]');
    var form = button && (button.form || button.closest('form'));

    if (!button || !isNativeProductForm(form)) {
      return;
    }

    if (button.matches('[data-ginyhome-quick-purchase-trigger]')) {
      if (getRequiredSelectionState(form).state !== 'complete') {
        validateRequiredSelections(form);

        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }

    if (getRequiredSelectionState(form).state === 'complete') {
      return;
    }

    validateRequiredSelections(form);

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}());
